import LoopText from "@quarkly/community-kit/LoopText";
export default LoopText;